import React, { Component } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Badge,
  Button,
  CustomInput,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { END_POINT_SOCKET } from "../../constants/defaultValues";import createSocket from "../../helpers/createSocket";
import classnames from "classnames";
import { withRouter } from "react-router-dom";

const NotificationItem = ({
  handleAlertUpdateSeen,
  toggleDropdown,
  history,
  id,
  isSeen,
  type,
  title,
  date,
  time,
  item_id,
}) => {
  const getLink = () => {
    if (type === "todo") return "/app/pages/todo";
    if (type === "service") return "/app"; // Dashboard where call-service alerts appear
    if (type === "stock" || type === "expiry")
      return `/app/pages/stock?item_id=${item_id}`;
    return null;
  };

  const getTextClass = () => {
    if (type === "expiry") return "text-warning";
    if (type === "stock") return "text-danger";
    if (type === "service") return "text-info";
    return "";
  };

  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    handleAlertUpdateSeen(id);
  };

  const handleNotificationClick = () => {
    handleAlertUpdateSeen(id);
    toggleDropdown();
    const link = getLink();
    if (link && history) {
      history.push(link);
    }
  };

  return (
    <div className="d-flex flex-row align-items-start mb-2 pb-2 border-bottom">
      {/* Checkbox đánh dấu đã đọc */}
      <div className="mr-2 pt-1">
        <CustomInput
          type="checkbox"
          id={`notif-${id}`}
          checked={isSeen}
          onChange={handleCheckboxClick}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
      {/* Nội dung thông báo */}
      <div
        className={classnames("flex-grow-1", {
          unseen: !isSeen,
        })}
        style={{ cursor: "pointer" }}
        onClick={handleNotificationClick}
      >
        <p
          className={classnames("mb-1", getTextClass(), {
            "font-weight-medium": !isSeen,
            "text-muted": isSeen,
          })}
          style={{ fontSize: "13px" }}
        >
          {title}
        </p>
        <p className="mb-0 text-small text-muted" style={{ fontSize: "11px" }}>
          {date + " - " + time}
        </p>
      </div>
    </div>
  );
};

const EmptyNotification = ({ message }) => (
  <div className="text-center text-muted py-4">
    <i className="simple-icon-bell mr-2" />
    {message}
  </div>
);

class TopnavNotifications extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      alert_data: [],
      un_seen_len: 0,
      dropdownOpen: false,
      activeTab: "1",
    };

    this.socket = createSocket();
  }

  componentDidMount() {
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });
    this.socket.emit("join room", {
      room_id: localStorage.getItem("b"),
    });

    this.socket.emit("refresh-alert-data", {
      user_id: localStorage.getItem("b"),
    });

    this.socket.on("refresh-alert-data", (res) => {
      const { data, un_seen_len, un_seen_without_mess } = res;

      this.setState({
        isLoading: true,
        alert_data: data,
        un_seen_len,
        un_seen_without_mess,
      });
    });
  }

  handleAlertUpdateSeen = (uuid) => {
    console.log("handleAlertUpdateSeen called with uuid:", uuid);
    this.socket.emit("update-seen-alert-data", {
      user_id: localStorage.getItem("b"),
      uuid,
    });
  };

  handleMarkAllAsRead = (types) => {
    console.log("handleMarkAllAsRead called with types:", types);
    const typeArray = Array.isArray(types) ? types : [types];
    const notifications = this.state.alert_data.filter(
      (d) => typeArray.includes(d.type) && !d.isSeen,
    );

    console.log(
      "Marking notifications:",
      notifications.map((n) => ({ id: n.id, type: n.type })),
    );

    notifications.forEach((notif) => {
      this.socket.emit("update-seen-alert-data", {
        user_id: localStorage.getItem("b"),
        uuid: notif.id,
      });
    });
  };

  toggleDropdown = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  getFilteredData = (types) => {
    if (Array.isArray(types)) {
      return this.state.alert_data.filter((data) => types.includes(data.type));
    }
    return this.state.alert_data.filter((data) => data.type === types);
  };

  getUnseenCount = (types) => {
    if (Array.isArray(types)) {
      return this.state.alert_data.filter(
        (d) => types.includes(d.type) && !d.isSeen,
      ).length;
    }
    return this.state.alert_data.filter((d) => d.type === types && !d.isSeen)
      .length;
  };

  renderNotificationList = (notifications, type) => {
    const unseenCount = notifications.filter((n) => !n.isSeen).length;

    return (
      <>
        {/* Nút đánh dấu tất cả đã đọc */}
        {unseenCount > 0 && (
          <div className="px-3 pb-2 mb-2 border-bottom">
            <Button
              color="link"
              size="sm"
              className="p-0 text-primary"
              onClick={() => this.handleMarkAllAsRead(type)}
            >
              <i className="simple-icon-check mr-1" />
              Đánh dấu tất cả đã đọc ({unseenCount})
            </Button>
          </div>
        )}

        {/* Danh sách thông báo */}
        {notifications.length === 0 ? (
          <EmptyNotification message="Không có thông báo" />
        ) : (
          notifications.map((notification, index) => (
            <NotificationItem
              location={this.props.location}
              history={this.props.history}
              key={notification.id || index}
              {...notification}
              handleAlertUpdateSeen={this.handleAlertUpdateSeen}
              toggleDropdown={this.toggleDropdown}
            />
          ))
        )}
      </>
    );
  };

  render() {
    const { un_seen_without_mess, isLoading, dropdownOpen, activeTab } =
      this.state;

    const generalData = this.getFilteredData(["todo", "service"]);
    const stockData = this.getFilteredData("stock");
    const expiryData = this.getFilteredData("expiry");

    const generalUnseen = this.getUnseenCount(["todo", "service"]);
    const stockUnseen = this.getUnseenCount("stock");
    const expiryUnseen = this.getUnseenCount("expiry");

    return !isLoading ? (
      <div className="loading" />
    ) : (
      <div className="position-relative d-inline-block">
        <UncontrolledDropdown
          className="dropdown-menu-right"
          isOpen={dropdownOpen}
          toggle={this.toggleDropdown}
        >
          <DropdownToggle
            className="header-icon notificationButton"
            color="empty"
          >
            <i
              className={classnames("iconsminds-bell", {
                "text-primary": un_seen_without_mess > 0,
              })}
            />
            <span className={un_seen_without_mess > 0 ? "count" : "uncount"}>
              {un_seen_without_mess ? un_seen_without_mess : 0}
            </span>
          </DropdownToggle>
          <DropdownMenu
            className="position-absolute mt-3"
            right
            id="notificationDropdown"
            style={{ minWidth: "350px", maxHeight: "500px" }}
          >
            {/* Tab Navigation */}
            <Nav tabs className="nav-tabs-notification mb-2">
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => this.toggleTab("1")}
                  style={{
                    cursor: "pointer",
                    fontSize: "12px",
                    padding: "8px 12px",
                    color: activeTab === "1" ? undefined : "#696969",
                  }}
                >
                  Chung{" "}
                  {generalUnseen > 0 && (
                    <Badge color="primary" pill className="ml-1">
                      {generalUnseen}
                    </Badge>
                  )}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => this.toggleTab("2")}
                  style={{
                    cursor: "pointer",
                    fontSize: "12px",
                    padding: "8px 12px",
                    color: activeTab === "2" ? undefined : "#696969",
                  }}
                >
                  Sắp hết{" "}
                  {stockUnseen > 0 && (
                    <Badge color="danger" pill className="ml-1">
                      {stockUnseen}
                    </Badge>
                  )}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "3" })}
                  onClick={() => this.toggleTab("3")}
                  style={{
                    cursor: "pointer",
                    fontSize: "12px",
                    padding: "8px 12px",
                    color: activeTab === "3" ? undefined : "#696969",
                  }}
                >
                  Hết hạn{" "}
                  {expiryUnseen > 0 && (
                    <Badge color="warning" pill className="ml-1">
                      {expiryUnseen}
                    </Badge>
                  )}
                </NavLink>
              </NavItem>
            </Nav>

            {/* Tab Content */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <PerfectScrollbar
                  options={{
                    suppressScrollX: true,
                    wheelPropagation: false,
                  }}
                  style={{ maxHeight: "400px", paddingTop: "8px" }}
                >
                  {this.renderNotificationList(generalData, [
                    "todo",
                    "service",
                  ])}
                </PerfectScrollbar>
              </TabPane>
              <TabPane tabId="2">
                <PerfectScrollbar
                  options={{
                    suppressScrollX: true,
                    wheelPropagation: false,
                  }}
                  style={{ maxHeight: "400px", paddingTop: "8px" }}
                >
                  {this.renderNotificationList(stockData, "stock")}
                </PerfectScrollbar>
              </TabPane>
              <TabPane tabId="3">
                <PerfectScrollbar
                  options={{
                    suppressScrollX: true,
                    wheelPropagation: false,
                  }}
                  style={{ maxHeight: "400px", paddingTop: "8px" }}
                >
                  {this.renderNotificationList(expiryData, "expiry")}
                </PerfectScrollbar>
              </TabPane>
            </TabContent>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    );
  }
}

export default withRouter(TopnavNotifications);
